import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import IButton from '../../components/button/i-button.component';
import { GridColDef } from '@mui/x-data-grid';
import IGridComponent from '../../components/grid/i-grid.component';

const SpecParametersGrid = (props: any) => {
  const [specParams] = useState(props.specParams);
  const [specParamsOriginal, setSpecParamsOriginal] = useState([]);
  const columns: GridColDef[] = [
    { field: 'spec', headerName: 'Specification', filterable: false, editable: false, sortable: false, width: 200, },
    { field: 'specValue', headerName: 'Specification Value', filterable: false, editable: true, sortable: false, type: 'singleSelect',
      valueOptions: ({id}) => { return specParams[Number(id)].specValueList; },
      valueFormatter: (specValue: any) => specValue, 
      valueSetter: (value, row) => { row.specValue = value; return value; },
      width: 200
    }
  ]

  useEffect(() => {
    setSpecParamsOriginal(JSON.parse(JSON.stringify(specParams)));
  }, [])

  const onSubmit = () => {
    props.close(specParams);
  }

  const onCancel = () => {
    props.close(specParamsOriginal);
  }

  return(
    <div>
      <Grid container spacing={1}>
        <IGridComponent title='' rows={specParams} columns={columns} getRowId={(row: any) => row.id}
          apiRef={props.apiRef} showAction={false} showAddBtn={false} hideFooterPagination={true}
          showExtBtn={false} hideFooter={true} showExtBtn2={false}/>
      </Grid>
      <div className='btn-panel'>
        <IButton name='submit' label='Submit' color="primary" onActionEvent={onSubmit}/>
        <IButton name='cancel' label='Cancel' color="secondary" onActionEvent={onCancel}/>
      </div>
    </div>
  )
}

export default SpecParametersGrid;